"use strict";
module.exports = {
    DEFAULT_CURRENCY_CODE: 'USD'
};
